import React from 'react'
import { Icon } from '@st-operations/uikit/src/v2'

const InfoTooltip = ({ text }) => {
  return (
    <If condition={text}>
      <div className="h-[18px]" data-tooltip-text={text} data-tooltip-direction="right">
        <Icon
          className="text-gray-700 w-[18px] h-[18px] cursor-pointer"
          type="outline"
          icon="info"
        />
      </div>
    </If>
  )
}

export default InfoTooltip
